import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/sonner'
import { queryClient } from '@/lib/queryClient'
import { routes } from './routes'
import './styles/tailwind.css'

// Canonical URL din variabila de mediu (build: APP_URL / VITE_APP_URL)
const appUrl = import.meta.env.VITE_APP_URL
if (appUrl) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'canonical'
    document.head.appendChild(link)
  }
  link.href = appUrl
}

// Apply saved theme before paint (default: light). 'system' (set from
// /setari's 3-way control — same `theme` key, see features/setari/lib/theme.ts)
// resolves against the OS preference at load time; anything else unrecognized
// falls back to light, same as before.
const saved = localStorage.getItem('theme')
const prefersDarkOS = window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
const isDark = saved === 'dark' || (saved === 'system' && prefersDarkOS)
if (isDark) document.documentElement.classList.add('dark')
else document.documentElement.classList.remove('dark')

const router = createBrowserRouter(routes)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" />
    </QueryClientProvider>
  </React.StrictMode>,
)
